// Maps at-risk flag keys (emitted by backend-tenant src/services/analytics/risk.js)
// to a chip tone.

const NEG = new Set(['past_due', 'canceled', 'no_activity', 'kb_incomplete']);
const WARN = new Set([
  'cancel_scheduled',
  'trial_expiring',
  'seats_full',
  'inactive_users',
  'no_training',
  'low_training',
  'low_call_quality'
]);
const INFO = new Set(['renewal_soon']);

/** Every flag key the portal has a tone for (the drift guard compares it to the backend's). */
export const TONED_FLAG_KEYS: ReadonlyArray<string> = [...NEG, ...WARN, ...INFO];

export type ChipTone = 'neg' | 'warn' | 'info' | '';

export const flagTone = (key: string): ChipTone => {
  if (NEG.has(key)) return 'neg';
  if (WARN.has(key)) return 'warn';
  if (INFO.has(key)) return 'info';
  return '';
};

/** Subscription status -> status pill tone. */
export const statusTone = (status: string): 'pos' | 'warn' | 'neg' => {
  // 'trial' = trial access (not billed through Stripe), healthy by design.
  if (['active', 'trialing', 'trial'].includes(status)) return 'pos';
  if (['past_due', 'grace_period', 'incomplete'].includes(status)) return 'warn';
  if (['canceled', 'unpaid'].includes(status)) return 'neg';
  return 'warn';
};
